// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Kafc","notes":"Notes_notes__q3LfV"};